import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap5/Form';

import {
  ErrorMessage,
  useField,
  Field,
} from 'formik';

export default function HorizontalSelectCheckboxField(props) {
  const {
    name, label, collection, hint, required, wrapperClassName, containerClassName, optionClassName,
  } = props;

  const [field] = useField(props);

  return (
    <Form.Group className={wrapperClassName} controlId="formBasicEmail">
      {label && (
        <Form.Label>
          <>
            {label}
            {required && <abbr className="ms-1" title="required">*</abbr>}
          </>
        </Form.Label>
      )}

      <div className={containerClassName}>
        {collection.map((item) => (
          <div className={`form-check ${optionClassName}`}>
            <Field
              className="form-check-input"
              id={`${field.name}-${item.value}`}
              type="checkbox"
              name={field.name}
              value={item.value}
            />
            <label title="" htmlFor={`${field.name}-${item.value}`} className="form-check-label">{item.label}</label>
          </div>
        ))}
      </div>

      {hint && <Form.Text className="text-muted">{hint}</Form.Text>}

      <ErrorMessage
        name={name}
        render={(msg) => <Form.Control.Feedback type="invalid">{msg}</Form.Control.Feedback>}
      />
    </Form.Group>
  );
}

HorizontalSelectCheckboxField.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  collection: PropTypes.arrayOf(PropTypes.object).isRequired,
  hint: PropTypes.string,
  required: PropTypes.bool,
  wrapperClassName: PropTypes.string,
  containerClassName: PropTypes.string,
  optionClassName: PropTypes.string,
};

HorizontalSelectCheckboxField.defaultProps = {
  hint: '',
  required: false,
  wrapperClassName: 'mb-3',
  containerClassName: 'text-center',
  optionClassName: '',
};
